/**
 * Evaluate a single condition rule against current strap selections.
 * Handles "value||customText" encoding — only the choice part is compared.
 */
export function evalRule(rule, selections) {
    const raw = selections[rule.optionKey] || '';
    const val = typeof raw === 'string' && raw.includes('||') ? raw.slice(0, raw.indexOf('||')) : raw;
    switch (rule.operator) {
        case 'is':           return val === rule.value;
        case 'is_not':       return val !== rule.value;
        case 'contains':     return val.includes(rule.value);
        case 'not_contains': return !val.includes(rule.value);
        default:             return true;
    }
}

/**
 * Determine whether a strap option should be visible given current selections.
 * Rules within a group use OR; groups themselves use groupLogic (and/or).
 * If none of the referenced options have been selected yet, all options are shown.
 */
export function isOptionVisible(opt, selections) {
    const c = opt.conditions;
    if (!c || !c.enabled) return true;
    const groups = c.groups || [];
    if (groups.length === 0) return c.action !== 'hide';

    const referencedKeys = groups
        .flatMap(g => (g.rules || []).map(r => r.optionKey))
        .filter(Boolean);

    const anySelected = referencedKeys.some(k => {
        const v = selections[k];
        return v !== undefined && v !== null && String(v).trim() !== '';
    });
    if (!anySelected) return true;

    const groupResults = groups.map(g =>
        !g.rules || g.rules.length === 0
            ? true
            : g.rules.some(r => evalRule(r, selections))
    );
    const conditionMet = c.groupLogic === 'or'
        ? groupResults.some(Boolean)
        : groupResults.every(Boolean);
    return c.action === 'hide' ? !conditionMet : conditionMet;
}
